/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {Component} from 'react';
import PropTypes from 'prop-types';

class DisplayUpdatedValue extends Component {
    constructor() {
        super();

        this.state = {
            value: ""
        }
    }

    updateValue() {
        if (this.props.getValue !== undefined) {
            let newValue = this.props.getValue()

            if (newValue !== this.state.value) {
                this.setState({value: newValue})
            }
        }
    }


    componentDidMount() {
        this.updateValue()
        this.inverval = setInterval(() => {
            this.updateValue()
        }, this.props.interval)
    }

    componentWillUnmount() {
        clearInterval(this.inverval)
    }

    render() {
        return (this.state.value);
    }
}

DisplayUpdatedValue.propTypes = {
    getValue: PropTypes.func.isRequired,
    interval: PropTypes.number
};

DisplayUpdatedValue.defaultProps = {
    interval: 2000
}

export default DisplayUpdatedValue;